import { FC } from 'react';
import CustomLazyPicker from 'src/view/components/Controls/Pickers/CustomLazyPicker/CustomLazyPicker';
import client from 'src/services/client';
import { IPagination } from 'src/types/main';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';
import { RESTRICTION_ACCESS } from '~/constants/integrations';
import { localeStore } from '~/mobx/localesStore';

interface IProps {
  id: string;
  code: string;
  access?: RESTRICTION_ACCESS;
  visibleOptionsNum?: number;
  onSelect: (id: string, code: string) => void;
}

export const CurrencyPicker: FC<IProps> = ({ id, code, access, visibleOptionsNum = 5, onSelect }): JSX.Element => {
  const handleCurrencySelect = (options: IPickerOption[]) => {
    const option = options[0];
    if (option) onSelect(option.value, option.label);
  };

  return (
    <IntegrationManager setting={access} withTooltip>
      <CustomLazyPicker
        selectedOptions={id ? [{ label: code, value: id }] : undefined}
        defaultPlaceholder={localeStore.t('select_currency')}
        inputClassName="w-100"
        maxNumberOfVisibleOptions={visibleOptionsNum}
        onSelect={handleCurrencySelect}
        onFetch={fetchCurrencies}
      />
    </IntegrationManager>
  );
};

const fetchCurrencies = async (page: number): Promise<IPagination<any>> => {
  const currenciesPagination: IPagination<any> = await client.get('v4/currencies', { params: { page } });
  return { ...currenciesPagination, data: currenciesPagination.data.map((currency) => ({ ...currency, name: currency.currency_code })) };
};
